export const partners = ["allstate", "encompass", "one-beacon", "aviva", "nationwide", "state-farm", "chiron"] as const;

// eslint-disable-next-line prettier/prettier
export type Partner = (typeof partners)[number];

export type CompOnlyType = "STANDARD" | "EXCESS_TPL";
